import Vue from 'vue';

Vue.component('accordion-animation-wrapper', {
    props: {
        accordionButtonClass: {
            type: String,
        },
        accordionBodyClass: {
            type: String,
        },
        isFirstChildActiveByDefault: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            activeIndex: this.isFirstChildActiveByDefault ? 0 : null,
        };
    },

    mounted() {},

    methods: {
        toggleItem(index) {
            this.activeIndex = this.activeIndex === index ? null : index;
        },

        isAccordionItemActive(index) {
            return this.activeIndex === index
                ? `${this.accordionBodyClass}--active`
                : '';
        },

        isButtonClicked(index) {
            return this.activeIndex === index
                ? `${this.accordionButtonClass}--active`
                : '';
        },
    },
});
